/**
 * Need only one of this rights
 */
export const SQDC_ASSING_MINIMUM_RIGHTS = ["sqdc.read", "sqdc.admin", "sqdc.write"];
